var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.notices),function(item,index){return _c('notice-average-price',{key:index,attrs:{"variant":item.noticeType,"text":item.noticeString,"linkText":item.linkText,"linkHref":item.linkHref}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }